<template>
  <div :class="getPlaceholderClass()" class="flex items-center justify-center rounded-full shrink-0 w-11 h-11">
    <Icon :class="getIconClass()" :name="resolveIcon()" size="base" />
  </div>
</template>
<script setup lang="ts">
import { ToastMessage, TOAST_TYPE } from '@/store/useToastStore';
import { Icon } from '@/storybook/icon';

const props = defineProps<{
  msg: ToastMessage;
}>();

const iconPlaceHolderClass = {
  success: 'bg-slate-50 dark:bg-zinc-800',
  info: 'bg-slate-50 dark:bg-zinc-800',
  warn: 'bg-orange-200 dark:bg-orange-800',
  error: 'bg-red-200 dark:bg-red-800',
};

const iconClass = {
  success: 'bg-slate-50 dark:bg-zinc-800',
  info: 'bg-slate-50 dark:bg-zinc-800',
  warn: 'bg-orange-200 dark:bg-orange-800',
  error: 'bg-red-200 dark:bg-red-800',
};

const getPlaceholderClass = () => iconPlaceHolderClass[props.msg.type];
const getIconClass = () => iconClass[props.msg.type];

const resolveIcon = () => {
  if (props.msg.options?.icon) {
    return props.msg.options?.icon;
  }

  switch (props.msg.type) {
    case TOAST_TYPE.SUCCESS:
      return 'toast.success';
    case TOAST_TYPE.ERROR:
      return 'toast.error';
    default:
      return 'toast.info';
  }
};
</script>
